import * as React from 'react'
import { ReactElement } from 'react'
import { InjuryPanelProps } from './FormContainer'
import { Field } from '@fluentui/react-components'
import BaseCombobox from '../../Combobox/BaseCombobox'

type Props = InjuryPanelProps & {}

const DropdownOptions = ['Ja', 'Nee', 'Onbekend']

export default function OccupationalAccidentPanel(props: Props): ReactElement {
    return (
        <div className={props.styles.formRow}>
            <Field label="Bij therapeut geweest" orientation={props.orientation}>
                <BaseCombobox
                    options={DropdownOptions}
                    getOptionLabel={entity => entity}
                    getOptionValue={entity => entity}
                />
            </Field>
            <Field label="Ziekenhuisopname" orientation={props.orientation}>
                <BaseCombobox
                    options={DropdownOptions}
                    getOptionLabel={entity => entity}
                    getOptionValue={entity => entity}
                />
            </Field>
        </div>
    )
}
